/**
 * 修复linkcrm使用top对象导致不能被嵌入第三方系统问题
 * @type {Window}
 */
let iframeTop = window
if(window !== top) {
  try{
    while (iframeTop !== top) {
      if(iframeTop.parent.location.href){
        // 若跨域访问了就会抛出异常，此时当前iframeTop即为linkcrm同域下最上层页面
        iframeTop = iframeTop.parent;
      }
    }
  }catch (e) {
    // 若跨域访问了就会抛出异常，此时当前iframeTop即为linkcrm同域下最上层页面
  }
}
const CURRENT_ORIGIN_TOP = iframeTop;
window.CURRENT_ORIGIN_TOP = CURRENT_ORIGIN_TOP; // 赋值到当前window对象
